import { axiosRequest } from '@/util/axios-request';

// 班次添加
export var shiftAdd = function shiftAdd(data) {
  return axiosRequest({
    url: '/web/attendance/shift_add',
    data: data
  });
};

// 班次详情
export var shiftInfo = function shiftInfo(data) {
  return axiosRequest({
    url: '/web/attendance/shift_info',
    data: data
  });
};

// 班次修改
export var shiftEdit = function shiftEdit(data) {
  return axiosRequest({
    url: '/web/attendance/shift_edit',
    data: data
  });
};

// 添加班次获取必要的信息
export var addShiftInfo = function addShiftInfo(data) {
  return axiosRequest({
    url: '/web/attendance/addShiftInfo',
    data: data
  });
};

// 班次删除
export var shiftDel = function shiftDel(data) {
  return axiosRequest({
    url: '/web/attendance/shift_del',
    data: data
  });
};

// 班次列表
export var shiftList = function shiftList(data) {
  return axiosRequest({
    url: '/web/attendance/shift_list',
    data: data
  });
};